import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_SELECT_CONFIG, MatSelectModule } from '@angular/material/select';
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { CdkTableModule } from "@angular/cdk/table";
import { MatTableModule } from "@angular/material/table";
/** Redux */
/** Copmponents */
import { NotificationComponent } from '@components/notification/notification.component';
import { HeaderComponent } from '@components/header/header.component';
import { FieldFormComponent } from '@components/field_form/field_form.component';
import { ButtonComponent } from '@components/button/button.component';
import { PasswordRecoveryComponent } from '@components/passwordRecovery/passwordRecovery.component';
import { SidebarComponent } from '@components/sidebar/sidebar.component';
import { NavbarComponent } from '@components/navbar/navbar.component';
import { ListComponent } from '@components/tables/list/list.component';
import { SelectDocumentTypeComponent } from '@components/field_form/selects/select-document-type/select-document-type.component';
import { SelectHiringCompanyComponent } from '@components/field_form/selects/select-hiring-company/select-hiring-company.component';
import { SelectGenderComponent } from '@components/field_form/selects/select-gender/select-gender.component';
import { SelectRolGroupComponent } from '@components/field_form/selects/select-rol-group/select-rol-group.component';
import { SelectWorkScheduleTypeComponent } from '@components/field_form/selects/select-work-schedule-type/select-work-schedule-type.component';
import { SelectEmployeeComponent } from '@components/field_form/selects/select-employee/select-employee.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { SpecialLatlongComponent } from '@components/field_form/specials/special-latlong/special-latlong.component';
import { SelectActiveComponent } from '@components/field_form/selects/select-active/select-active.component';
import { SelectUserRolComponent } from '@components/field_form/selects/select-user-rol/select-user-rol.component';
import { SelectLocationComponent } from '@components/field_form/selects/select-location/select-location.component';
import { LoaderComponent } from '@components/loader/loader.component';
import { SelectTenantComponent } from "@components/field_form/selects/select-tenant/select-tenant.component";
import { QuestionnaireQuestionFormComponent } from "@components/field_form/questionnaire-question-form/questionnaire-question-form.component";
import { NotificationGeneralComponent } from "@components/notification-general/notification-general.component";
import { TenantDialogComponent } from "@components/tenat-dialog/tenant-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    MatFormFieldModule,
    FormsModule,
    MatMenuModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    CdkTableModule,
    MatTableModule,
    GoogleMapsModule
  ],
  declarations: [
    HeaderComponent,
    FieldFormComponent,
    NotificationComponent,
    NotificationGeneralComponent,
    LoaderComponent,
    ButtonComponent,
    PasswordRecoveryComponent,
    SidebarComponent,
    NavbarComponent,
    ListComponent,
    SelectDocumentTypeComponent,
    SelectHiringCompanyComponent,
    SelectGenderComponent,
    SelectRolGroupComponent,
    SelectWorkScheduleTypeComponent,
    SelectEmployeeComponent,
    SpecialLatlongComponent,
    SelectActiveComponent,
    SelectUserRolComponent,
    SelectLocationComponent,
    SelectTenantComponent,
    QuestionnaireQuestionFormComponent,
    TenantDialogComponent
  ],
  exports: [
    NotificationComponent,
    FieldFormComponent,
    HeaderComponent,
    ButtonComponent,
    PasswordRecoveryComponent,
    SidebarComponent,
    NavbarComponent,
    ListComponent,
    LoaderComponent,
    QuestionnaireQuestionFormComponent,
    NotificationGeneralComponent
  ],
  providers: [

  ]
})
export class ComponentsModule { }
